import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, ArrowLeft } from "lucide-react";
import { api, LOGO_MARK } from "../lib/api";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking"); // checking | paid | failed | timeout
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 10) { setState("timeout"); return; }
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); setInfo(data); return; }
        if (data.status === "expired") { setState("failed"); return; }
        setTimeout(poll, 2000);
      } catch { setTimeout(poll, 2000); }
    };
    poll();
  }, [params]);

  return (
    <div className="grain relative min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center rounded-xl border border-white/10 bg-[#12141A] p-10" data-testid="booking-result">
        <img src={LOGO_MARK} alt="E.O.VO" className="h-14 w-14 object-contain mx-auto mb-6" />
        {state === "checking" && <><Loader2 className="animate-spin mx-auto text-[#C8A97E]" size={40} /><h1 className="font-head text-2xl mt-5">Confirming payment…</h1><p className="text-[#A1A1AA] mt-2">Please wait a moment.</p></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto text-[#C8A97E]" size={48} /><h1 className="font-head text-3xl mt-5">Booking Confirmed!</h1>
          <p className="text-[#A1A1AA] mt-3">Thank you — your payment of <span className="text-[#C8A97E] font-semibold">${(info?.amount_total / 100).toFixed(2)}</span> was received. Evan will reach out shortly to kick off your project.</p></>}
        {(state === "failed" || state === "timeout") && <><XCircle className="mx-auto text-[#E04F5F]" size={48} /><h1 className="font-head text-2xl mt-5">{state === "timeout" ? "Still processing" : "Payment not completed"}</h1>
          <p className="text-[#A1A1AA] mt-3">{state === "timeout" ? "Check your email for confirmation, or contact Evan." : "Your booking was cancelled or failed. No charge was made."}</p></>}
        <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 mt-8 text-sm text-[#C8A97E] hover:underline"><ArrowLeft size={15} /> Back to home</Link>
      </div>
    </div>
  );
}
